import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('Ivr').extend('Uuid');

Factory.define('IvrWithDefaults')
  .extend('Ivr')
  .attr('version', 1)
  .attr('name', 'Friendly IVR name')
  .attr('description', 'an-ivr-description');


// WEBPACK FOOTER //
// ./factories/ivr_factory.js